import { FC } from 'react';

import { Box, Center, Heading, Text, VStack } from '@bonusly/design-system';

// Error boundary for the public route tree. The app's RouteError /
// AppContentFallback assume the authenticated shell (identity-aware chrome), so
// the anonymous public form needs its own session-free fallback. It renders a
// neutral message and never leaks why the route failed — consistent with the
// backend collapsing missing / soft-deleted / feature-off to an indistinct 404.
export const PublicRouteError: FC = () => {
	return (
		<Center flexGrow={1} p={8}>
			<Box maxW="32rem" textAlign="center">
				<VStack spacing={4}>
					<Heading size="lg">This link isn’t available</Heading>
					<Text color="fg.muted">
						The recognition link you followed can’t be loaded right now. Double-check the link or ask the person who shared it for an updated one.
					</Text>
				</VStack>
			</Box>
		</Center>
	);
};
